<template>
  <div class="bg-white rounded-xl shadow-sm p-5 border border-gray-100">
    <h3 class="text-lg font-bold text-gray-800 mb-4">Evolución de tu Precisión</h3>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <div class="h-64 relative bg-gray-50 rounded-lg p-4">
          <b-skeleton animation="wave" height="100%" width="100%"></b-skeleton>
        </div>
      </template>
      <div class="h-64 relative">
        <line-chart v-if="loaded" :chart-data="historyData" :options="lineOptions" style="height: 100%; width: 100%;" />
      </div>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs';
import { getModuleEvolutionKpi } from '@/services/CourseStats.service';

// Componente Line Chart Wrapper
const LineChart = {
  extends: Line,
  props: ['chartData', 'options'],
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};

export default {
  name: 'ModuleEvolutionKpi',

  components: {
    LineChart
  },

  data() {
    return {
      loading: true,
      loaded: false,

      // --- DATA GRÁFICA DE LÍNEA (HISTÓRICO) ---
      historyData: {
        labels: ['Sem 1', 'Sem 2', 'Sem 3', 'Sem 4', 'Actual'],
        datasets: [
          {
            label: 'Precisión (%)',
            borderColor: '#3B82F6', // Azul Mobius
            backgroundColor: 'rgba(59, 130, 246, 0.1)',
            borderWidth: 3,
            pointBackgroundColor: '#FFFFFF',
            pointBorderColor: '#3B82F6',
            pointRadius: 4,
            data: [0, 0, 0, 0, 0],
            fill: true,
            tension: 0.4 // Curvas suaves
          }
        ]
      },
      lineOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          yAxes: [{
            ticks: { beginAtZero: true, max: 100 },
            gridLines: { borderDash: [4, 4] }
          }],
          xAxes: [{ gridLines: { display: false } }]
        }
      },
    };
  },

  props: {
    courseId: {
      type: Number,
      required: true,
      default: 0
    },
    isPremium: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    courseId(newValue) {
      // No cargar datos si no es premium
      if (!this.isPremium) {
        return;
      }
      this.fetchKpiData(newValue);
    },
    isPremium(newValue) {
      // Si el usuario se vuelve premium, cargar los datos
      if (newValue && this.courseId) {
        this.loading = true;
        this.fetchKpiData(this.courseId);
      }
    }
  },

  created() {
    // Si no es premium, mantener loading indefinidamente y no cargar datos
    if (!this.isPremium) {
      this.loading = true;
      return;
    }
    
    this.fetchKpiData(this.courseId);
  },

  mounted() {
    // Si no es premium, mantener skeleton indefinidamente
    if (!this.isPremium) {
      this.loading = true;
    }
  },

  methods: {
    async fetchKpiData(courseId) {
      if (!courseId || !this.isPremium) return;

      try {
        const kpiData = await getModuleEvolutionKpi(courseId);

        this.historyData.labels = kpiData.labels;
        this.historyData.datasets[0].data = kpiData.data;

        this.loaded = true;
        this.loading = false; // Ocultar skeleton inmediatamente después de cargar
      } catch (error) {
        console.error("Error al cargar datos del gráfico:", error);
        this.loading = false; // Ocultar skeleton incluso si hay error
      }
    },
  },
}
</script>